import React, { useState } from "react";
import { BsCheckCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { logoLight } from "../../assets/images";
import { Helmet } from "react-helmet";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [errPassword, setErrPassword] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleEmail = (e) => {
    setEmail(e.target.value);
    setErrEmail("");
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
    setErrPassword("");
  };

  const handleSignIn = (e) => {
    e.preventDefault();
    if (!email) setErrEmail("Enter your work email address");
    if (!password) setErrPassword("Enter your password");

    if (email && password) {
      setSuccessMsg(
        `Thank you for signing in! Your access request is being processed. Additional instructions will be sent to ${email}.`
      );
      setEmail("");
      setPassword("");
    }
  };

  return (
    <div className="w-full h-screen flex items-center justify-center bg-gray-50">
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Sign In - RK Global Trader | International Export & Import Solutions</title>
        <meta
          name="description"
          content="Sign in to RK Global Trader for access to premium international export and import services. Secure login for verified partners and clients."
        />
        <meta
          name="keywords"
          content="RK Global Trader sign in, export business login, international trade access, import services login, secure login RK Global Trader, global trading platform"
        />
        <meta name="author" content="RK Global Trader | Export & Import Services from India" />
        <link rel="canonical" href="https://www.rkglobaltrader.com/signin" />
      </Helmet>

      {/* Left Info Panel */}
      <div className="w-1/2 hidden lgl:flex h-full bg-primeColor text-white flex-col px-10 justify-center gap-6">
        <Link to="/">
          <img src={logoLight} alt="RK Global Trader Logo" className="w-28" />
        </Link>
        <div>
          <h1 className="font-titleFont text-xl font-medium">Secure Sign In</h1>
          <p className="text-base">Access your RK Global Trader account for global trading.</p>
        </div>
        <div className="flex flex-col gap-3">
          <div className="flex items-start gap-3">
            <BsCheckCircleFill className="text-green-500 mt-1" />
            <p className="text-base text-gray-300">
              <strong className="text-white">Quick Access:</strong> Efficiently manage your international trade orders, export documentation, and client interactions.
            </p>
          </div>
          <div className="flex items-start gap-3">
            <BsCheckCircleFill className="text-green-500 mt-1" />
            <p className="text-base text-gray-300">
              <strong className="text-white">Trusted Platform:</strong> Verified and secure login ensures safety for all your export & import operations.
            </p>
          </div>
          <div className="flex items-start gap-3">
            <BsCheckCircleFill className="text-green-500 mt-1" />
            <p className="text-base text-gray-300">
              <strong className="text-white">24/7 Support:</strong> Contact us anytime for assistance with international trading and business solutions.
            </p>
          </div>
        </div>
        <div className="flex justify-between mt-10 text-sm text-gray-300">
          <Link to="/">© RK Global Trader</Link>
          <p>Terms</p>
          <p>Privacy</p>
          <p>Security</p>
        </div>
      </div>

      {/* Sign In Form */}
      <div className="w-full lgl:w-1/2 h-full flex items-center justify-center bg-gray-50">
        {successMsg ? (
          <div className="w-full lgl:w-[500px] h-full flex flex-col justify-center items-center">
            <p className="w-full px-4 py-10 text-green-600 font-medium font-titleFont text-center">
              {successMsg}
            </p>
            <Link to="/signup">
              <button className="w-full h-10 bg-primeColor text-white rounded-md hover:bg-black hover:text-gray-100 transition duration-300">
                Create New Account
              </button>
            </Link>
          </div>
        ) : (
          <form className="w-full lgl:w-[450px] flex flex-col justify-center px-6 py-4 bg-white shadow-lg rounded-md">
            <h1 className="font-titleFont underline decoration-[1px] font-semibold text-3xl mb-6 text-center">
              Sign In
            </h1>

            {/* Email Field */}
            <div className="mb-4">
              <label className="block text-gray-600 font-semibold mb-1">Work Email</label>
              <input
                type="email"
                value={email}
                onChange={handleEmail}
                placeholder="importer@workemail.com"
                className="w-full h-10 px-4 border border-gray-300 rounded-md text-base outline-none focus:ring-2 focus:ring-primeColor"
              />
              {errEmail && <p className="text-red-500 mt-1 text-sm">{errEmail}</p>}
            </div>

            {/* Password Field */}
            <div className="mb-4">
              <label className="block text-gray-600 font-semibold mb-1">Password</label>
              <input
                type="password"
                value={password}
                onChange={handlePassword}
                placeholder="Enter your password"
                className="w-full h-10 px-4 border border-gray-300 rounded-md text-base outline-none focus:ring-2 focus:ring-primeColor"
              />
              {errPassword && <p className="text-red-500 mt-1 text-sm">{errPassword}</p>}
            </div>

            <button
              onClick={handleSignIn}
              className="w-full h-10 bg-primeColor text-white rounded-md hover:bg-black hover:text-gray-100 transition duration-300 mb-4"
            >
              Sign In
            </button>

            <p className="text-center text-sm text-gray-600">
              Don't have an account?{" "}
              <Link to="/signup">
                <span className="text-blue-600 hover:text-blue-800 font-medium">Sign Up</span>
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default SignIn;
